const MAPBOX_KEY = 'pk.eyJ1IjoiZ3VpZG9zLWNsb3VkIiwiYSI6ImNreDZhNXljYzJjMGIyd3A5dzk3OWhwZ24ifQ.gmeWfU97TP3AKvBWqj7D7g';
const API_URL = 'https://api.guidos.fun';

const TRANSLATE_URL='https://libraries.guidos.fun/highlight/'

export {
    MAPBOX_KEY,
    API_URL,
    TRANSLATE_URL
}